import React, { useState, useEffect } from 'react';
import {ReactComponent as IconLoading} from "../assets/icon-loading.svg";
import {CSSTransition} from "react-transition-group";

import './Overlay.scss';

interface LoadingProps{
    show: boolean;
    children?: React.ReactChild | null;
    variant?: 'dark' | 'light';
    animated?: boolean;
    delay?: number;
}

export default function Overlay(props: LoadingProps){
    const variant = props.variant || 'dark';
    const animated = props.animated !== false;
    const delay = props.delay || 0;

    const [visible, setVisible] = useState(delay === 0 && props.show);

    useEffect(() => {
        if (delay === 0) {
            setVisible(props.show);
            return;
        }

        if (props.show) {
            const timer = setTimeout(() => setVisible(true), delay);
            return () => clearTimeout(timer);
        } else {
            setVisible(false);
        }
    }, [props.show, delay]);

    if (!animated) {
        if (!visible) return null;
        return (
            <div className={`overlay overlay-${variant}`}>
                { !props.children ? <IconLoading /> : props.children }
            </div>
        );
    }

    return (
        <CSSTransition unmountOnExit in={visible} timeout={300} classNames="overlay">
            <div className={`overlay overlay-${variant}`}>{ !props.children ? <IconLoading /> : props.children }</div>
        </CSSTransition>
    )
}